export default "__VITE_ASSET__CdWH1MxI__"